jQuery(function ($) {
  if (!$(".home-hero-slider").length || !$.fn.slick) return;
  $(".home-hero-slider").slick({
    autoplay: true,
    autoplaySpeed: 4500,
    speed: 600,
    fade: true,
    cssEase: "linear",
    dots: true,
    arrows: true,
    prevArrow: $(".home-hero-prev"),
    nextArrow: $(".home-hero-next"),
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    pauseOnFocus: false,
  });
});
